module.exports = __webpack_public_path__ + "img/tima2.91eeffd0.png";